<!-- <canvas *ngIf="!editMode" id="{{id}}" class="canvas-area" [style.height.px]="widgetheight">
</canvas>
<canvas *ngIf="editMode" id="{{id}}" class="canvas-area"  [style.height.px]="widgetheight-50">
</canvas>
<button *ngIf="editMode" type="button" class="btn btn-outline" (click)="runInitScript()">Run Init script</button>
<button *ngIf="editMode"type="button" class="btn btn-outline"(click)="runDataUpdateScript()">Run Update script</button> -->
<div [style.height.px]="widgetheight" class="scripted3d-widget">
  <canvas id="{{id}}" class="canvas-area" [style.height.px]="widgetheight">
  </canvas>
  <button *ngIf="editMode" type="button" class="btn btn-outline" (click)="runInitScript()">Run Init script</button>
  <button *ngIf="editMode"type="button" class="btn btn-outline"(click)="runDataUpdateScript()">Run Update script</button>
</div>
